module.exports = "<header>\r\n  <app-nav></app-nav>\r\n</header>"